import moment from "moment";

export const extractData = (dateRange, defaultChannel) => {
  const fmt = (value) => moment(value).format("YYYY-MM-DD");
  const [{ startDate, endDate, previousStartDate, previousEndDate }] = dateRange;

  return {
    pub_id: localStorage.getItem("pub_id"),
    channel_id: defaultChannel?.channel_id,
    role_id: +localStorage.getItem("role_id"),
    start_date: fmt(startDate),
    end_date: fmt(endDate),
    prev_start_date: fmt(previousStartDate),
    prev_end_date: fmt(previousEndDate),
  };
};

export default extractData;
